import {Component, EventEmitter, Output} from '@angular/core';
import {AuthenticationService, CredentialsLoginRequest} from '@ngx-ivengi/authentication';
import {UIRouter} from '@uirouter/angular';
// import {InsecureRouteService} from './../insecure-route/insecure-route.service';
// import {LoaderService} from '../loader/loader.service';
import {Observable} from 'rxjs/Observable';
import {LocaleService, ILanguageItems} from '@ngx-ivengi/locale';
import {InsecureRouteService, LoaderService} from '@ngx-ivengi/cleanzone';

export interface LoginAttemptResponse {
  success: boolean;
}

@Component({
  selector: 'ngx-cleanzone-login',
  templateUrl: './login.component.html'
})
export class LoginComponent {

  @Output() public onLoginAttempt: EventEmitter<LoginAttemptResponse> = new EventEmitter<LoginAttemptResponse>();

  public availableLanguages: ILanguageItems = LocaleService.getLanguages();
  public username: string;
  public password: string;
  public isLoading: Observable<boolean> = this.loaderService.isLoading();
  public fields: InsecureRouteService = this.insecureRouteService;

  constructor(
    private router: UIRouter,
    private authService: AuthenticationService,
    private insecureRouteService: InsecureRouteService,
    private loaderService: LoaderService,
    private localeService: LocaleService
  ) {
  }

  public get currentLanguageISO() {
    return LocaleService.getCurrentLanguageISO();
  }

  public set currentLanguageISO(languageISO: string) {
    this.localeService.setCurrentLanguageISO(languageISO);
  }

  public signIn() {
    const request: CredentialsLoginRequest = new CredentialsLoginRequest(this.username, this.password);
    this.authService.login(request).subscribe(
      (_data) => {
        this.onLoginAttempt.emit({success: true});
        if(this.authService.getDeepLink()) {
          this.router.stateService.go(
            (<{state: string, params: {[key: string]: string} | null}>this.authService.getDeepLink()).state,
            (<{state: string, params: {[key: string]: string} | null}>this.authService.getDeepLink()).params
          );
        } else {
          this.router.stateService.go(this.authService.config.getRootState());
        }
      },
      (_err) => {
        this.onLoginAttempt.emit({success: false});
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/login/login.component.ts